/// <reference path = "../../components/common/notificationTags.constants.ts" />

module Meevo.Plugins.WalkinManagerKiosk {
    // TODO run jsdoc comments to methods

    import IWalkinAppointment = Meevo.Plugins.WalkinManager.IWalkinAppointment;
    const ICONS = {
        'Haircuts': 'haircuts',
        'Color': 'color',
        'Nails': 'nails',
        'Waxing': 'wax',
        'Other': 'blank'
    };

    const APPOINTMENT_UPDATE_INTERVAL = 15000;
    const KEEP_ALIVE_INTERVAL = 60000;

    import ClientFoundState = Meevo.Model.ClientFoundState;
    import ClientFoundType = Meevo.Model.ClientFoundType;
    import IWalkinAppointmentSave = Meevo.Model.IWalkinAppointmentSave;
    import WalkInStatusEnum = Meevo.Model.WalkInStatusEnum;
    import NotificationTags = Meevo.Components.Common.NotificationTags;
    import IScanService = Meevo.Plugins.WalkinManager.AddToWaitlist.IScanService;
    import IWalkinAppointmentResponse = Meevo.Plugins.WalkinManager.IWalkinAppointmentResponse;
    import IAddonService = Meevo.Plugins.WalkinManager.AddToWaitlist.IAddonService;

    interface IClientFuzzyResponse {
        clientEmail: string,
        clientFoundState: ClientFoundState,
        clientFoundType: ClientFoundType,
        clientId?: string,
        walkinAppointmentStatusUpdated?: boolean,
        clientFirstName?: string
        clientAddress?: Meevo.Model.Address,
        clientLastName?: string,
        employeeGenderSearchEnum?: Meevo.Model.EmployeeGenderSearchEnum,
        serviceDisplayName?: string,
        employeeNickname?: string,
        appointmentId?: Guid,
        appointmentEntityVersion?: number,
        note?: string
        possibleClients?: Meevo.Model.ClientListItem[]
    }

    interface ISpecificEmployee {
        employee: Model.Employee,
        isAvailable: boolean,
        opening?: Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceOpening
    }

    class WalkinManagerKioskController {

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        servicePage: number;
        employeePreference: string;
        employeePreferenceOptions: Array<string>;
        serviceOpening: Array<Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceOpening>;
        exitButtonVisible: boolean;
        private refreshInterval: ng.IPromise<any>;
        public client: any;
        public currentPosition: number;
        public timeBeforeClear: number;
        public timeoutPromise: ng.IPromise<any>;
        public intervalPromise: ng.IPromise<any>;
        public checkInPhoneNumber: string;
        public checkInCountryCode: string;
        public clientForm: any;
        public clientAddressForm: any;
        public sessionTimeout: any;
        public popularServiceTime: string;
        public confirmationMessage: Array<string>;
        public employeeWasSelected: boolean;
        public welcomeHeader: string;
        public specificEmployeeList: Array<ISpecificEmployee>;
        public isClientNew: boolean;
        public acceptedTerms: boolean = false;
        public customerInfoStepNumber: number = 3;
        public bookingPhoneNumber: string;
        public bookingCountryCode: string;
        public selectedServiceAddOns: IAddonService[] = [];
        public numberOfGuestsModel: number = 0;
        public numberOfCurrentGuest: number = 0; // =0 is a client; >0 is a guest
        public servicesToBook: Array<IScanService> = [];
        public emailValidationPattern: RegExp = Meevo.Components.Common.Constants.REGEX_EMAIL_VALIDATOR;

        private waitListInterval: ng.IPromise<any>;
        private associatedStateName: string;

        static $inject = [
            '$scope',
            'meevo.AppSettings', 'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.SecurityService',
            '$rootScope', '$state', '$q', '$interval', '$timeout', '$sanitize', '$translate',
            'meevo.plugins.walkinManager.addToWaitlist.employeeListService',
            'meevo.plugins.walkinManager.addToWaitlist.serviceCategoryListService',
            'meevo.plugins.walkinManager.addToWaitlist.ScanForOpeningsService',
            'meevo.plugins.walkinManager.WalkInSettingsService',
            'meevo.plugins.walkinManager.WalkinAppointmentService',
            'restServer'
        ];

        public get canAddedGuests(): boolean {
            return this.walkInSettingsService.settings.maximumNumberOfWalkinGuests !== 0;
        }

        public get isAddingGuests(): boolean {
            return this.numberOfCurrentGuest !== 0;
        }

        public get isLastGuest(): boolean {
            return this.numberOfCurrentGuest === this.numberOfGuestsModel;
        }

        get showShoppingCart(): boolean {
            return [0, 1, 2, 3, 4, 5, 7, 8].indexOf(this.servicePage) !== -1;
        }

        get clientEmailRequired(): boolean {
            return this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.requireNewClientEmail;
        }

        constructor(
            protected $scope: ng.IScope,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: ng.IQService,
            protected $interval: ng.IIntervalService,
            protected $timeout: ng.ITimeoutService,
            protected $sanitize: ng.sanitize.ISanitizeService,
            protected $translate: ng.translate.ITranslateService,
            protected employeeListService: Meevo.Plugins.WalkinManager.AddToWaitlist.IEmployeeList,
            protected serviceCategoryListService: Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceCategoryList,
            protected scanForOpeningsService: Meevo.Plugins.WalkinManager.AddToWaitlist.IScanForOpeningsService,
            protected walkInSettingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService,
            protected walkinAppointmentService: Meevo.Plugins.WalkinManager.IWalkinAppointmentService,
            protected restServer: any
        ) {
            window.addEventListener('keydown', (e) => {
                var handled = false;
                if (e.key !== undefined && e.key === 'F5') {
                    handled = true;
                    this.startOver();
                } else if (e.keyCode !== undefined && e.keyCode === 116) {
                    handled = true;
                    this.startOver();
                }
                if (handled) {
                    e.preventDefault();
                }
            });

            this.exitButtonVisible = false;
            this.checkInPhoneNumber = '';
            this.bookingPhoneNumber = '';
            this.employeeWasSelected = false;

            if (!_.isEmpty($state)) {
                this.associatedStateName = $state.current.name;
            }

            this.clear(false);

            this.stopSessionTimeout();

            this.securityService.checkSecurityKey(this.securityKeys.APPOINTMENTS_WALKINMANAGERKIOSK_ACTION_EXIT)
                .then((securityCode: Meevo.Model.SecurityAccessEnum) => {
                    this.exitButtonVisible = securityCode === Meevo.Model.SecurityAccessEnum.Grant;
                });

            this.initData();

            //this.restartKeepAliveInterval();

            this.setWatchers();
        }

        public setWatchers(): void {
            this.$scope.$watch(() => this.client.phoneNumber, (newVal, oldValue) => {
                if (newVal && newVal !== oldValue) {
                    this.restartSessionTimeout();
                }
            });

            this.$scope.$watch(() => this.checkInPhoneNumber, (newVal, oldValue) => {
                if (newVal && newVal !== oldValue) {
                    this.restartSessionTimeout();
                }
            });

            this.$scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
                if (toState.name === this.associatedStateName) {
                    this.initData();
                }
            });
        }

        public initData(): void {
            this.busyService.start();

            this.employeePreferenceOptions = ['First Available', 'First Available Male', 'First Available Female'];

            this.walkInSettingsService.fetchSettings()
                .then(() => {
                    this.getWalkInAppointments();

                    if (!this.walkInSettingsService.kioskServiceId) {
                        this.modalService
                            .warning('MESSAGE_MOST_POPULAR_SERVICE_IS_NOT_SET', Meevo.Components.Modal.ModalTranslationModes.Translate)
                            .then(() => this.exitKiosk(false));
                        this.busyService.stop();
                    } else {
                        this.fetchStartData();
                    }

                    if (this.walkInSettingsService.settings.hideAnyGenderOptions) {
                        this.employeePreferenceOptions = _.reject(this.employeePreferenceOptions, ((pref) => {
                            return pref.toLowerCase().indexOf('male') > 0;
                        }));
                    }

                    this.welcomeHeader = this.$translate.instant('LABEL_WELCOME_TO_HEADER') + this.walkInSettingsService.settings.businessName;
                });

            this.employeeListService.searchCriteria = {
                eligibleForWalkinManager: true,
                view: Meevo.Model.EmployeeSearchView.WithEmployeeServicePricing,
                walkinAppointmentSearchView: Meevo.Model.WakinAppointmentSearchView.Default
            };
        }

        fetchStartData() {
            this.$q.all([
                this.serviceCategoryListService.fetchCategoryList(),
                this.employeeListService.fetchEmployees(this.walkInSettingsService.settings.showOnlyClockedInEmployees),
                this.scanForOpeningsService.scan({
                    serviceId: this.walkInSettingsService.kioskServiceId
                }, 'First Available')
                    .then((opening: Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceOpening) => {
                        if (opening.waitTime === 0) {
                            this.popularServiceTime = 'Next';
                        } else {
                            this.popularServiceTime = `${opening.waitTime}:00`;
                        }
                    })
                    .catch((conflictMessage) => {
                        if (conflictMessage) {
                            this.modalService
                                .alert(conflictMessage, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                        }

                        this.popularServiceTime = 'See Front Desk';
                    })
            ])
                .finally(() => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        clear(resetSessionTimer: boolean = true): void {
            this.servicePage = 12; // initialize first index

            this.$timeout.cancel(this.timeoutPromise);
            this.$interval.cancel(this.intervalPromise);

            this.employeeListService.currentEmployee = null;
            this.serviceCategoryListService.currentCategory = null;
            this.serviceCategoryListService.currentService = null;
            this.currentPosition = 0;
            this.serviceOpening = null;
            this.employeePreference = null;
            this.acceptedTerms = false;
            this.bookingPhoneNumber = '';
            this.employeeWasSelected = false;
            this.servicesToBook = [];
            this.selectedServiceAddOns = [];

            this.client = {
                firstName: '',
                lastName: '',
                countryCode: '',
                phoneNumber: '',
                note: '',
                email: '',
                id: null,
                isSMSEnabled: false,
                waitInWaitingArea: false
            };

            if (resetSessionTimer) {
                this.restartSessionTimeout();
            }

            this.restartWaitListInterval();
        }

        closeContext(targetStateName: string = null, createContext = false): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, targetStateName, createContext);
        };

        getCategoryIconName(categoryName: string): string {
            let iconName = ICONS[categoryName];

            if (typeof iconName === 'undefined') {
                iconName = ICONS['Other'];
            }

            return iconName;
        }

        selectServiceCategory(category: Meevo.Model.ServiceCategory): void {
            this.serviceCategoryListService.currentCategory = category;
            this.employeeListService.searchCriteria.serviceId = null;
            this.serviceCategoryListService.fetchServicesList(category.id);

            this.stepForward();
        }

        selectService(service: Meevo.Plugins.WalkinManager.AddToWaitlist.IService) {
            var filteredArray = _.filter(this.servicesToBook, (s) => s.serviceId === service.id);
            if (filteredArray.length === 1) {
                this.modalService.warning('MESSAGE_KIOSK_SERVICE_ALREADY_SELECTED', Meevo.Components.Modal.ModalTranslationModes.Translate);
                return;
            } else {
                if (this.serviceCategoryListService.currentService) {
                    var serv = _.find(this.servicesToBook, (s) => {
                        return s.serviceId === this.serviceCategoryListService.currentService.id;
                    });
                    if (serv) {
                        serv.serviceId = service.id;
                        serv.serviceDisplayName = service.displayName;
                    }
                }
                this.serviceCategoryListService.currentService = service;
                this.employeeListService.searchCriteria.serviceId = service.id;
                this.selectedServiceAddOns = [];

                this.employeeListService.fetchEmployees(this.walkInSettingsService.settings.showOnlyClockedInEmployees);

                this.restServer.getAppointmentServiceTemplateWithAddOns(
                    null,
                    service.id,
                    [],
                    null,
                    null,
                    (response: any) => {
                        if (response && response.hasServiceAddOn) {
                            let options: Meevo.Components.Modal.IModalOptions = {
                                templateUrl: "app/plugins/AppointmentBook/views/serviceAddOns.html",
                                controller: "meevo.plugins.appointmentBook.ServiceAddOnsController",
                                bindToController: true,
                                locals: {
                                    serviceId: service.id,
                                    employeeId: null,
                                    currentServiceAddOns: this.selectedServiceAddOns,
                                    finalState: null,
                                    transitionState: null,
                                    isReadOnly: false,
                                    isFromWalkIn: true,
                                    clientId: null,
                                    equipmentValidator: null,
                                    yieldManagementDateTime: undefined,
                                    applyProductUsage: false,
                                    appointmentServiceId: undefined
                                },
                                controllerAs: "vm"
                            }
                            this.modalService.showCustom(options).then(response => {
                                switch (response.action) {
                                    case 'save':
                                        this.selectedServiceAddOns = response.data;
                                        break;
                                    case 'close':
                                    case 'cancel':
                                        const hasRequired = response.data;
                                        if (hasRequired) {
                                            this.serviceCategoryListService.currentService = null;
                                        }
                                        break;
                                }
                                this.stepForward();
                                });
                        } else {
                            this.stepForward();
                        }
                    }
                );
            }
        }

        selectEmployeePreference(option: string): void {
            this.employeePreference = option;
            this.changeEmployeePreference();
        }

        changeEmployeePreference(): void {
            if (this.employeePreference === 'Specific Service Provider') {
                this.employeeListService.fetchEmployees(this.walkInSettingsService.settings.showOnlyClockedInEmployees);
            } else {
                this.employeeListService.currentEmployee = null;
            }
            this.stepForward();
        }

        selectEmployee(employee: Meevo.Model.Employee): void {
            this.employeeListService.currentEmployee = employee;
            this.employeePreference = null;
            this.stepForward();
        }

        exitKiosk(popularServiceDefined: boolean = true): void {
            let options = {
                templateUrl: 'app/plugins/walkinManagerKiosk/exitKiosk/exit.modal.html',
                controller: 'meevo.plugins.walkinManagerKiosk.exitKiosk.ExitKioskController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    oneTry: false,
                    isKiosk: true
                }
            };

            // if we open exit modal on response for most popular service
            // than give only one try for user credentials
            options.locals.oneTry = !popularServiceDefined;
            // ------

            this.stopSessionTimeout();
            this.stopWaitListInterval();
            this.modalService.showCustom(options)
                .then(() => {
                    this.serviceCategoryListService.clear();
                    this.employeeListService.clear();
                    this.$interval.cancel(this.refreshInterval);
                    this.stopSessionTimeout();

                    if (popularServiceDefined) {
                        this.closeContext();
                    } else {
                        this.closeContext(this.appSettings.ROUTE_NAMES.walkinManagerSettings, true);
                    }
                })
                .catch(() => {
                    this.restartWaitListInterval();
                    if (popularServiceDefined) {
                        this.restartSessionTimeout();
                    } else {
                        this.modalService.warning('MESSAGE_EST_TIME_MOST_POPULAR_SERVICE_IS_NOT_SET', Meevo.Components.Modal.ModalTranslationModes.Translate);
                        this.restartSessionTimeout();
                    }
                });
        }

        private getWalkInAppointments(): ng.IPromise<any> {
            return this.walkinAppointmentService.fetchWalkInAppointments(Meevo.Model.WaitListStatus.Default);
        }

        stepForward(): void {

            switch (this.servicePage) {
                case 0:
                    this.servicePage += 1;
                    this.restartSessionTimeout();
                    if (this.walkInSettingsService.settings.showKioskCurrentWaitList) {
                        this.stopWaitListInterval();
                    }
                    break;
                case 1:
                    if (this.serviceCategoryListService.currentService !== null) {
                        if (this.walkInSettingsService.settings.defaultFirstAvailableEmployee) {
                            this.employeePreference = 'First Available';
                            this.servicePage += 2;
                            this.customerInfoStepNumber = 2;
                            this.stepForwardFromEmployee();
                        } else {
                            this.servicePage += 1;
                            this.restartSessionTimeout();
                        }
                    }
                    break;
                case 2:
                    //if (this.employeePreference) {
                    //    this.servicePage += 2;
                    //    //if (this.employeePreference.toLowerCase().indexOf('specific') == -1) {
                    //    //    this.stepForwardFromEmployee();
                    //    //}
                    //    this.stepForwardFromEmployee();
                    //}
                    this.servicePage += 1;
                    this.stepForwardFromEmployee();
                    break;
                case 3:
                    this.stepForwardFromEmployee();
                    break;
                case 4:
                    this.stepForwardFromClientPhone();
                    break;
                case 5:
                    this.stepForwardFromClient();
                    break;
            }
        };

        stepForwardFromEmployee(): void {
            let employeeLabel;
            let id;

            if (this.employeeListService.currentEmployee === null) {
                employeeLabel = this.employeePreference;
                id = null;
            } else {
                employeeLabel = `${this.employeeListService.currentEmployee.displayName}: ${this.employeeListService.currentEmployee.firstName}`;
                id = this.employeeListService.currentEmployee.id;
            }

            let serv = _.find(this.servicesToBook, (s) => {
                return s.serviceId === this.serviceCategoryListService.currentService.id;
            });

            if (serv) {
                serv.employeeId = id;
                serv.employeeLabel = employeeLabel;
                serv.genderPreferenceEnum = this.scanForOpeningsService.getGenderInfo(employeeLabel);
                serv.employeePreference = this.employeePreference;
                serv.addOnServices = this.selectedServiceAddOns;
            } else {
                this.servicesToBook.push({
                    serviceId: this.serviceCategoryListService.currentService.id,
                    employeeId: id,
                    employeeLabel: employeeLabel,
                    clientId: null,
                    genderPreferenceEnum: this.scanForOpeningsService.getGenderInfo(employeeLabel),
                    employeePreference: this.employeePreference,
                    addOnServiceIds: this.selectedServiceAddOns.map(addon => addon.addOnServiceId),
                    addOnServices: this.selectedServiceAddOns,
                    serviceDisplayName: this.serviceCategoryListService.currentService.displayName
                });
            }

            this.busyService.start();
            this.stopSessionTimeout();

            this.scanForOpeningsService.scan(this.servicesToBook, employeeLabel, id)
                .then((serviceOpening: Array<Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceOpening>) => {
                    this.serviceOpening = serviceOpening;
                    this.servicePage += 1;
                    // Save this for when SFO is enhanced to return multiple openings per time slot.

                    //this.specificEmployeeList = [];
                    //_.each(this.employeeListService.employees, (employee) => {
                    //  let empOpening = _.find(serviceOpenings, (container: any) => {
                    //    return _.find(container.serviceOpenings, (opening: any) => {
                    //      return opening.employeeId.toString() === employee.id;
                    //    });
                    //  });
                    //  if (empOpening) {
                    //    this.specificEmployeeList.push({
                    //      employee: employee,
                    //      isAvailable: true,
                    //      opening: empOpening
                    //    });
                    //  } else {
                    //    this.specificEmployeeList.push({
                    //      employee: employee,
                    //      isAvailable: false,
                    //      opening: null
                    //    });
                    //  }
                    //});

                    this.employeeWasSelected = true;
                })
                .catch((conflictMessage) => {
                    let message = '';

                    if (typeof conflictMessage === 'undefined') {
                        if (this.employeePreference === 'First Available') {
                            const tagCollection = {
                                [NotificationTags.WALKIN_URL]: this.walkInSettingsService.settings.publicOnlineWaitListUrl,
                                [NotificationTags.BUSINESS_NAME]: this.walkInSettingsService.settings.businessName
                            };
                            message = this.parseMessageWithTags(this.walkInSettingsService.settings.notifications.appointmentBookFullMessage, tagCollection);
                        } else {
                            if (this.employeePreference === 'Male Only' || this.employeePreference === 'Female Only') {
                                message = 'Sorry, your selection is currently fully booked for the rest of the day.';
                            } else {
                                message = 'Sorry, this employee is currently fully booked for the rest of the day. Please select another Employee';
                            }
                            this.servicePage = 2;
                        }
                    } else {
                        message = conflictMessage;
                    }
                    this.modalService.alert(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                })
                .finally(() => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        stepForwardFromClientPhone(): void {
            if (this.bookingPhoneNumber === '') {
                return;
            }
            this.busyService.start();
            this.stopSessionTimeout();
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/WalkinAppointment/ClientInfo`, 'POST', {
                'phone1': this.bookingPhoneNumber,
                'countryCode': this.bookingCountryCode,
                'isCheckinAppointmentSearch': false,
                'firstName': '',
                'lastName': ''
            })
                .then((response) => {
                    let data: IClientFuzzyResponse = response.data,
                        message = '';

                    if (data.clientFoundState === ClientFoundState.Existing) {
                        if (!data.possibleClients) {
                            // One match
                            this.client.id = data.clientId;
                            this.client.firstName = data.clientFirstName;
                            this.client.lastName = data.clientLastName;
                            this.client.phoneNumber = this.bookingPhoneNumber;
                            this.client.countryCode = this.bookingCountryCode;
                            this.client.clientAddress = data.clientAddress;
                            this.client.email = data.clientEmail;
                            this.acceptedTerms = true;
                            this.isClientNew = false;
                            this.servicePage += 1;
                        } else {
                            // Multiple matches
                            if (data.possibleClients.length > 0) {
                                let options: Meevo.Components.Modal.IModalOptions = {
                                    templateUrl: "app/plugins/walkinManagerKiosk/clientSelection/clientSelection.modal.html",
                                    controller: "meevo.plugins.walkinManagerKiosk.clientSelection.ClientSelectionModalController",
                                    controllerAs: "vm",
                                    bindToController: true,
                                    locals: {
                                        choices: data.possibleClients,
                                        phoneNumber: this.bookingPhoneNumber
                                    }
                                }

                                this.modalService.showCustom(options)
                                    .then((selection: any) => {
                                        if (selection) {
                                            this.client.id = selection.id;
                                            this.client.firstName = selection.firstName;
                                            this.client.lastName = selection.lastName;
                                            this.client.phoneNumber = this.bookingPhoneNumber;
                                            this.client.countryCode = this.bookingCountryCode;
                                            this.client.clientAddress = {
                                                address1: selection.address1,
                                                address2: selection.address2,
                                                city: selection.city,
                                                state: selection.state,
                                                zipCode: selection.zipCode
                                            };
                                            this.client.email = selection.emailAddress;
                                            this.acceptedTerms = true;
                                            this.isClientNew = false;
                                            this.servicePage += 1;
                                        }
                                        return selection;
                                    });
                            }
                        }
                    } else {
                        // No matches
                        this.client = {
                            firstName: '',
                            lastName: '',
                            countryCode: '',
                            phoneNumber: '',
                            note: '',
                            email: '',
                            id: null,
                            isSMSEnabled: false,
                            waitInWaitingArea: false
                        };
                        this.client.phoneNumber = this.bookingPhoneNumber;
                        this.client.countryCode = this.bookingCountryCode;
                        this.isClientNew = true;
                        this.acceptedTerms = false;
                        this.servicePage += 1;
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        clientEmailLookup(): void {
            if (this.client.firstName && this.client.lastName) {
                this.busyService.start();
                this.stopSessionTimeout();
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/WalkinAppointment/ClientInfo`, 'POST', {
                    'phone1': this.bookingPhoneNumber,
                    'countryCode': this.bookingCountryCode,
                    'isCheckinAppointmentSearch': false,
                    'firstName': this.client.firstName,
                    'lastName': this.client.lastName,
                    'email': this.client.email
                })
                    .then((response) => {
                        let data: IClientFuzzyResponse = response.data,
                            message = '';

                        if (data.clientFoundState === ClientFoundState.Existing) {
                            this.client.id = data.clientId;
                            this.client.firstName = data.clientFirstName;
                            this.client.lastName = data.clientLastName;
                            this.client.phoneNumber = this.bookingPhoneNumber;
                            this.client.countryCode = this.bookingCountryCode;
                            this.client.clientAddress = data.clientAddress;
                            this.acceptedTerms = true;
                            this.isClientNew = false;
                        } else {
                            // No matches
                            this.client.phoneNumber = this.bookingPhoneNumber;
                            this.client.countryCode = this.bookingCountryCode;
                            this.isClientNew = true;
                            this.acceptedTerms = false;
                        }
                    })
                    .finally(() => {
                        this.busyService.stop();
                        this.restartSessionTimeout();
                    });
            }
        }

        stepForwardFromClient(): void {
            if (this.clientForm.$invalid) {
                return;
            }
            this.stopSessionTimeout();

            if (!this.acceptedTerms) {
                this.busyService.stop();
                this.modalService.error('MESSAGE_WALKIN_AGREE_TERMS');
                return;
            }

            // if (this.isAddingGuests) {
            //     this.scanAndAdd();
            //
            //     return;
            // }

            this.busyService.start();

            let url = `${this.appSettings.API_ROOT}/WalkinAppointment/Client`;
            url += (this.isClientNew ? '' : `/${this.client.id}`);
            const method = (this.isClientNew ? 'POST' : 'PUT');

            this.dataService.customMethodData(url, method, {
                'email': this.client.email,
                'firstName': this.client.firstName,
                'lastName': this.client.lastName,
                'phone1': this.client.phoneNumber,
                'clientAddress': this.client.clientAddress,
                'countryCode': this.client.countryCode
            })
                .then((response) => {
                    let data: IClientFuzzyResponse = response.data;
                    this.client.id = data.clientId;
                    this.busyService.stop();
                    this.scanAndAdd();
                })
                .catch((error) => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });

            //this.dataService.customMethodData(`${this.appSettings.API_ROOT}/WalkinAppointment/ClientInfo`, 'POST', {
            //    'email': this.client.email,
            //    'firstName': this.client.firstName,
            //    'lastName': this.client.lastName,
            //    'phone1': this.client.phoneNumber,
            //    'countryCode': this.client.countryCode
            //})
            //    .then((response) => {
            //        let data: IClientFuzzyResponse = response.data;
            //        if ((data.clientFoundState === ClientFoundState.None && data.clientFoundType === ClientFoundType.None) ||
            //            (data.clientFoundState === ClientFoundState.CreatedNew)) {
            //            this.isClientNew = true;
            //        } else {
            //            this.isClientNew = false;
            //            this.client.id = data.clientId;
            //            this.client.clientAddress = data.clientAddress;
            //        }

            //        if (!this.acceptedTerms) {
            //            this.busyService.stop();
            //            this.modalService.error('MESSAGE_WALKIN_AGREE_TERMS');
            //            return;
            //        }

            //        let url = `${this.appSettings.API_ROOT}/WalkinAppointment/Client`;
            //        url += (this.isClientNew ? '' : `/${this.client.id}`);
            //        const method = (this.isClientNew ? 'POST' : 'PUT');

            //        this.client.clientAddress = {};

            //        this.dataService.customMethodData(url, method, {
            //            'email': this.client.email,
            //            'firstName': this.client.firstName,
            //            'lastName': this.client.lastName,
            //            'phone1': this.client.phoneNumber,
            //            'clientAddress': this.client.clientAddress,
            //            'countryCode': this.client.countryCode
            //        })
            //            .then((response) => {
            //                let data: IClientFuzzyResponse = response.data;
            //                this.client.id = data.clientId;
            //                this.busyService.stop();
            //                //this.acceptedTerms = false;
            //                //this.servicePage += 1;
            //                this.scanAndAdd();
            //                //if (this.walkInSettingsService.kioskClientEmail) {
            //                //    if (data.clientFoundState === ClientFoundState.None && data.clientFoundType === ClientFoundType.None) {
            //                //        this.client.emailRequired = true;
            //                //        this.busyService.stop();
            //                //        this.restartSessionTimeout();
            //                //    } else {
            //                //        this.client.id = data.clientId;
            //                //        this.scanAndAdd();
            //                //    }
            //                //} else {
            //                //    this.client.id = data.clientId;
            //                //    this.scanAndAdd();
            //                //}
            //            })
            //            .catch((error) => {
            //                this.busyService.stop();
            //                this.restartSessionTimeout();
            //            });

            //        //if (this.walkInSettingsService.kioskClientEmail) {
            //        //    if (data.clientFoundState === ClientFoundState.None && data.clientFoundType === ClientFoundType.None) {
            //        //        this.client.emailRequired = true;
            //        //        this.busyService.stop();
            //        //        this.restartSessionTimeout();
            //        //    } else {
            //        //        this.client.id = data.clientId;
            //        //        this.scanAndAdd();
            //        //    }
            //        //} else {
            //        //    this.client.id = data.clientId;
            //        //    this.scanAndAdd();
            //        //}
            //    })
            //    .catch((error) => {
            //        this.busyService.stop();
            //        this.restartSessionTimeout();
            //    });
        }

        stepForwardFromClientEntry(): void {
            if (this.clientAddressForm.$invalid) {
                return;
            }

            if (!this.acceptedTerms) {
                this.modalService.error('MESSAGE_WALKIN_AGREE_TERMS');
                return;
            }

            let url = `${this.appSettings.API_ROOT}/WalkinAppointment/Client`;
            url += (this.isClientNew ? '' : `/${this.client.id}`);
            const method = (this.isClientNew ? 'POST' : 'PUT');

            this.busyService.start();
            this.stopSessionTimeout();
            this.dataService.customMethodData(url, method, {
                'email': this.client.email,
                'firstName': this.client.firstName,
                'lastName': this.client.lastName,
                'phone1': this.client.phoneNumber,
                'clientAddress': this.client.clientAddress,
                'countryCode': this.client.countryCode
            })
                .then((response) => {
                    let data: IClientFuzzyResponse = response.data;
                    this.client.id = data.clientId;
                    this.busyService.stop();
                    this.acceptedTerms = false;
                    this.scanAndAdd();
                    //if (this.walkInSettingsService.kioskClientEmail) {
                    //    if (data.clientFoundState === ClientFoundState.None && data.clientFoundType === ClientFoundType.None) {
                    //        this.client.emailRequired = true;
                    //        this.busyService.stop();
                    //        this.restartSessionTimeout();
                    //    } else {
                    //        this.client.id = data.clientId;
                    //        this.scanAndAdd();
                    //    }
                    //} else {
                    //    this.client.id = data.clientId;
                    //    this.scanAndAdd();
                    //}
                })
                .catch((error) => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        prepareToAdd(): IWalkinAppointmentSave {
            const appt: IWalkinAppointmentSave = {
                clientId: this.client.id,
                note: this.client.note,
                bookingMethod: Meevo.Model.BookingMethodEnum.WalkinKiosk,
                isSMSEnabled: this.client.isSMSEnabled,
                statusEnum: this.client.waitInWaitingArea ? WalkInStatusEnum.WaitingAndPresent : WalkInStatusEnum.WaitingButNotPresent,
                moveToTop: false,
                suppressWarnings: true,
                services: []
            };

            _.forEach(this.serviceOpening, o => {
                var serviceInfo = _.find(this.servicesToBook, s => s.serviceId === o.serviceId.toString());
                appt.services.push({
                    id: null,
                    entityVersion: null,
                    serviceId: o.serviceId,
                    employeeId: o.employeeId,
                    startDateTime: o.startTime,
                    endDateTime: o.endTime,
                    employeeGenderSearchEnum: serviceInfo.genderPreferenceEnum,
                    nonRequest: o.nonRequest,
                    serviceAddOns: serviceInfo.addOnServices
                });
            });
            //if (this.selectedServiceAddOns.length > 0) {
            //    appt.services[0].serviceAddOns = [];
            //    this.selectedServiceAddOns.forEach(a => {
            //        appt.services[0].serviceAddOns.push({
            //            addOnServiceId: a.addOnServiceId,
            //            appointmentServiceId: this.serviceOpening.serviceId
            //        });
            //    });
            //}
            return appt;
        }

        scanAndAdd(): void {
            let scanService = {
                    serviceId: this.serviceCategoryListService.currentService.id,
                    clientId: this.client.id,
                    addOnServiceIds: this.selectedServiceAddOns
                },
                employeeNickName = this.serviceOpening[0].employeeName,
                employeeId = this.serviceOpening[0].employeeId;

            _.forEach(this.servicesToBook, (s) => {
                s.clientId = this.client.id;
            });

            this.busyService.start();
            this.stopSessionTimeout();
            this.stopWaitListInterval();

            this.scanForOpeningsService.scan(this.servicesToBook, employeeNickName, employeeId)
                .then((serviceOpening: Array<Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceOpening>) => {
                    this.serviceOpening = serviceOpening;

                    this.dataService.add('walkinAppointment', this.prepareToAdd())
                        .then((response) => {
                            if (response.isWarning) {
                                let warningMessage = "";

                                this.busyService.stop();

                                for (let warning of response.responseStatus.errors) {
                                    warningMessage += warning.message + " ";
                                }
                                warningMessage += " Do you want to continue?";

                                this.modalService.confirm(warningMessage)
                                    .then(() => {
                                        this.restartSessionTimeout();
                                        this.restartWaitListInterval();
                                    })
                                    .catch(() => {
                                        this.clear();
                                    });
                                this.restartSessionTimeout();
                                this.restartWaitListInterval();
                            } else {
                                this.busyService.stop();

                                if (this.isLastGuest) {
                                    this.goToSummaryPage();
                                } else {
                                    this.goToNextGuest();
                                }
                            }
                        })
                        .catch((error) => {
                            this.busyService.stop();
                            this.restartSessionTimeout();
                            this.restartWaitListInterval();
                        });
                })
                .catch((conflictMessage) => {
                    let message = 'Sorry, this employee is currently fully booked for the rest of the day. Please select another Employee';

                    if (conflictMessage) {
                        message = conflictMessage;
                    }

                    this.busyService.stop();
                    this.modalService
                        .alert(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    this.restartSessionTimeout();
                    this.restartWaitListInterval();
                });
        }

        goToSummaryPage(): void {
            this.servicePage += 1;
            this.busyService.start();
            this.stopSessionTimeout();

            this.dataService.getListPaged('WalkinAppointment', {
                criteria: {
                    view: Meevo.Model.EmployeeSearchView.Default,
                    employeeId: this.serviceOpening[0].employeeId
                }
            })
                .then((response: IWalkinAppointmentResponse | any) => {
                    const estimatedWaitTimes = response.items
                        .filter((app) => app.clientId === this.client.id)
                        .map((app) => Math.max(0, app.estimatedWaitTime));

                    const tagCollection = {
                        [NotificationTags.CLIENT_FIRSTNAME]: this.client.firstName.charAt(0).toUpperCase() + this.client.firstName.substr(1),
                        [NotificationTags.WALKIN_POSITION]: this.currentPosition,
                        [NotificationTags.WALKIN_ETA]: estimatedWaitTimes.length ? Math.min(...estimatedWaitTimes) : 0,
                        [NotificationTags.WALKIN_URL]: this.walkInSettingsService.settings.publicOnlineWaitListUrl,
                        [NotificationTags.EMPLOYEE]:
                            this.employeePreference && this.employeePreference.toLowerCase().indexOf('first') >= 0
                                ? this.employeePreference
                                : this.serviceOpening[0].employeeName,
                        [NotificationTags.SERVICE]: this.serviceOpening[0].serviceName,
                        [NotificationTags.BUSINESS_NAME]: this.walkInSettingsService.settings.businessName
                    };
                    this.confirmationMessage = this.parseMessageWithTags(this.walkInSettingsService.settings.notifications.customConfirmationPageMessage, tagCollection).split('\n');

                    this.currentPosition = response['items'].length;
                    this.setClearTimeout();
                })
                .finally(() => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        setClearTimeout(): void {
            this.timeBeforeClear = this.walkInSettingsService.kioskConfirmationTimeout;

            this.intervalPromise = this.$interval(() => {
                this.timeBeforeClear -= 1;
            }, 1000);

            this.timeoutPromise = this.$timeout(() => {
                this.clearQuestsData();
                this.clear();
            }, this.walkInSettingsService.kioskConfirmationTimeout * 1000);
        }

        stepBackward() {
            if (this.servicePage >= 1) { // don't over step bounds
                if (this.servicePage === 4) {
                    this.servicePage -= (this.walkInSettingsService.settings.defaultFirstAvailableEmployee ? 3 : 2);
                } else {
                    this.servicePage -= 1;
                }
                this.restartSessionTimeout();

                return;
            }

            if (this.servicePage === 0) {
                this.startOver();

                return;
            }
        }

        gotoCheckIn(): void {
            this.checkInPhoneNumber = '';
            this.checkInCountryCode = '';
            this.servicePage = 9;
        }

        getStarted() {
            this.servicePage = 0;
        }

        checkInSearch(): void {
            if (this.checkInPhoneNumber === '') {
                return;
            }

            this.busyService.start();
            this.stopSessionTimeout();
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/WalkinAppointment/ClientInfo`, 'POST', {
                'phone1': this.checkInPhoneNumber,
                'countryCode': this.checkInCountryCode,
                'isCheckinAppointmentSearch': true
            })
                .then((response) => {
                    let data: IClientFuzzyResponse = response.data,
                        message = '';

                    if (data.clientFoundState === ClientFoundState.Existing) {
                        this.client.firstName = data.clientFirstName;
                        this.client.lastName = data.clientLastName;
                        this.client.appointmentId = data.appointmentId;
                        this.client.appointmentEntityVersion = data.appointmentEntityVersion;
                        this.client.employeeGenderSearchEnum = data.employeeGenderSearchEnum;
                        this.client.serviceDisplayName = data.serviceDisplayName;
                        this.client.employeeNickname = data.employeeNickname;
                        this.client.note = data.note;
                        this.servicePage += 1;
                    } else {
                        message = 'Sorry, we were unable to check you in. Please see front desk.';
                        this.modalService.alert(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate)
                            .then(() => {
                                this.checkInPhoneNumber = '';
                                this.restartSessionTimeout();
                            });
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        getEmployeePreference(): string {
            let pref: string = '';

            switch (this.client.employeeGenderSearchEnum) {
                case Meevo.Model.EmployeeGenderSearchEnum.AnyEmployee:
                    pref = 'First Available';
                    break;
                case Meevo.Model.EmployeeGenderSearchEnum.AnyMale:
                    pref = 'First Available Male';
                    break;
                case Meevo.Model.EmployeeGenderSearchEnum.AnyFemale:
                    pref = 'First Available Female';
                    break;
                case Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee:
                    pref = 'Specific Service Provider';
                    break;
            }
            return pref;
        }

        isFirstAvailable(): boolean {
            return this.employeePreference && this.employeePreference.toLowerCase() == 'first available';
        }

        checkInClient(): void {
            if (this.checkInPhoneNumber === '') {
                return;
            }

            let model = {
                entityVersion: this.client.appointmentEntityVersion,
                statusEnum: Meevo.Model.WalkInStatusEnum.WaitingAndPresent
            };

            this.busyService.start();
            this.stopSessionTimeout();
            this.dataService.patch(`walkinAppointment`, {model: model}, this.client.appointmentId)
                .then((response) => {
                    let data: IClientFuzzyResponse = response.data,
                        message = '';

                    this.servicePage += 1;
                })
                .finally(() => {
                    this.busyService.stop();
                    this.restartSessionTimeout();
                });
        }

        public startOver(): void {
            this.stopSessionTimeout();
            this.modalService.confirm('LABEL_KIOSK_START_OVER', Meevo.Components.Modal.ModalTranslationModes.Translate)
                .then(() => {
                    this.clearQuestsData();
                    this.clear();
                })
                .catch(() => {
                    this.restartSessionTimeout();
                });
        }

        public showTermsModal(): void {
            let options = {
                templateUrl: 'app/plugins/walkinManagerKiosk/terms/terms.modal.html',
                controller: 'meevo.plugins.walkinManagerKiosk.terms.TermsModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    terms: this.walkInSettingsService.settings.termsAndConditions.termsAndConditionsText
                }
            };

            this.modalService.showCustom(options);
        }

        public viewWaitList(): void {
            let options = {
                templateUrl: 'app/plugins/walkinManagerKiosk/wimDisplay/wimDisplay.modal.html',
                controller: 'meevo.plugins.walkinManagerKiosk.wimDisplay.WimDisplayModalController',
                controllerAs: 'vm',
                bindToController: true
            };

            this.modalService.showCustom(options);
        }

        public goToNextGuest(): void {
            this.numberOfCurrentGuest += 1;
            this.stopSessionTimeout();
            this.stopWaitListInterval();
            this.clear();
        }

        public clearQuestsData() {
            this.numberOfGuestsModel = 0;
            this.numberOfCurrentGuest = 0;
        }

        public clearCurrentService(): void {
            this.serviceCategoryListService.currentCategory = null;
            this.serviceCategoryListService.currentService = null;
            this.employeePreference = null;
            this.employeeWasSelected = false;
            this.employeeListService.currentEmployee = null;
            this.selectedServiceAddOns = [];
        }

        public addService(): void {
            this.clearCurrentService();
            this.servicePage = 0;
        }

        public deleteService(service: IScanService): void {
            var message = this.$translate.instant('MESSAGE_KIOSK_DELETE_WARNING') +
                this.serviceCategoryListService.getServiceDisplayName(service.serviceId) + '?';
            this.modalService.confirm(message)
                .then(() => {
                    var index = _.findIndex(this.servicesToBook, (s) => s.serviceId === service.serviceId);
                    if (index > -1) {
                        this.servicesToBook.splice(index, 1);
                        if (this.servicesToBook.length === 0) {
                            this.clear();
                        }
                    }
                });
        }

        private stopSessionTimeout(): void {
            if (this.sessionTimeout) {
                this.$timeout.cancel(this.sessionTimeout);
                this.sessionTimeout = null;
            }
        }

        public restartSessionTimeout(): void {
            this.stopSessionTimeout();
            if (this.servicePage === 0 && this.serviceCategoryListService.currentCategory === null) {
                return;
            }

            this.sessionTimeout = this.$timeout(() => {
                this.runTimeoutModal();
            }, 300000); // 30sec
        }

        private stopWaitListInterval(): void {
            if (this.waitListInterval) {
                this.$interval.cancel(this.waitListInterval);
                this.waitListInterval = null;
            }
        }

        public restartWaitListInterval(): void {
            this.stopWaitListInterval();

            this.waitListInterval = this.$interval(() => {
                this.getWalkInAppointments();
            }, APPOINTMENT_UPDATE_INTERVAL);
        }


        public lettersOnly($event): void {
            if ($event.keyCode >= 48 && $event.keyCode <= 57) {
                $event.preventDefault();
            }
        }

        private runTimeoutModal(): void {
            let options = {
                templateUrl: 'app/plugins/walkinManagerKiosk/timeout/timeout.modal.html',
                controller: 'meevo.plugins.walkinManagerKiosk.timeout.TimeoutModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {}
            };

            this.stopSessionTimeout();
            this.modalService.showCustom(options)
                .then(() => this.restartSessionTimeout())
                .catch(() => this.clear());
        }

        private parseMessageWithTags(message: string, tags: Object): string {
            let notification = message;

            for (let i in tags) {
                notification = notification.replace(`{${i}}`,
                    '<span class="kiosk-confirm-tag">' + tags[i] + '</span>');
            }

            return notification;
        }
    }

    angular.module('meevo.plugins.walkinManagerKiosk')
        .controller('meevo.plugins.walkinManagerKiosk.walkinManagerKioskController', WalkinManagerKioskController);
}
